(() => {
  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const buildCard = (source, vendor, addLabel) => {
    const titleLink = source.querySelector('.card-title-change');
    const image = source.querySelector('img');
    const price = source.querySelector('.price-item--sale:not(:empty)') || source.querySelector('.price-item--regular');
    const productJson = source.querySelector('template')?.content?.querySelector('[data-json-product]');
    if (!titleLink || !image || !productJson) return null;

    let product;
    try {
      product = JSON.parse(productJson.getAttribute('data-json-product'));
    } catch (_error) {
      return null;
    }

    const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
    if (!variant) return null;

    const card = createElement('article', 'mishop-generic-card');
    const mediaLink = createElement('a', 'mishop-generic-card__media');
    mediaLink.href = titleLink.getAttribute('href');
    const cardImage = image.cloneNode(false);
    cardImage.loading = 'lazy';
    cardImage.decoding = 'async';
    mediaLink.append(cardImage);

    const content = createElement('div', 'mishop-generic-card__content');
    content.append(createElement('div', 'mishop-generic-card__vendor', vendor));
    const productLink = createElement('a', 'mishop-generic-card__title', titleLink.textContent.trim());
    productLink.href = titleLink.getAttribute('href');
    productLink.title = titleLink.textContent.trim();
    content.append(productLink);
    content.append(createElement('div', 'mishop-generic-card__price', price?.textContent.trim() || ''));

    const form = createElement('form', 'mishop-generic-card__form mishop-promotion-card__form');
    form.method = 'post';
    form.action = '/cart/add';
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = variant.id;
    const button = createElement('button', '', variant.available ? addLabel : 'Agotado');
    button.type = 'submit';
    button.name = 'add';
    button.disabled = !variant.available;
    form.append(input, button);
    content.append(form);
    card.append(mediaLink, content);
    return card;
  };

  const loadSection = async (section) => {
    if (section.dataset.mishopVendorLoaded === 'true') return;
    section.dataset.mishopVendorLoaded = 'true';
    const grid = section.querySelector('[data-category-rail]');
    if (!grid) return;

    try {
      const response = await fetch(section.dataset.mishopVendorUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const limit = Number.parseInt(section.dataset.mishopVendorLimit, 10) || 6;
      const cards = [...page.querySelectorAll('#product-grid > .product-grid__item')]
        .map((item) => buildCard(item, section.dataset.mishopVendorName, section.dataset.mishopAddLabel))
        .filter(Boolean)
        .slice(0, limit);
      if (!cards.length) throw new Error('No products returned');
      grid.replaceChildren(...cards);
      requestAnimationFrame(() => section.dispatchEvent(new CustomEvent('mishop:rail:refresh')));
    } catch (_error) {
      const message = grid.querySelector('[data-mishop-vendor-loading]');
      if (message) message.textContent = 'No se pudieron cargar los productos. Ver todos los productos LUMICRAFT.';
    }
  };

  const init = () => document.querySelectorAll('[data-mishop-vendor-url]').forEach(loadSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
